import { styled } from 'styled-components';

import { CardTitle } from 'common/components/Card/CardTitle';

export const CardIconButtonTitle = styled(CardTitle)`
    white-space: pre-line;
    text-align: center;
    margin-top: ${({ theme }) => theme.spacing(-1)};
`;
